export default __webpack_public_path__ + "static/media/loader.e50be628.svg";